const menu = {
    label: 'Solução',
    icon: 'lightbulb',
    to: '/sol/solucoes',
    rules: ['SOL-001'],
};

export default menu;
